<template>
  <div 
    class="popupWrap" 
    :class="{ 'active' : openOrClose }" 
    @click="dimmedClickHandler" 
  >
    <div class="contentWrap" ref="contentWrap">
      <slot :name="crntObj.slotName" />
    </div>
  </div>
</template>

<!-- publicActive -->

<script>
export default {
  props : {
    crntObj : Object , 
    openBln : {
      type : Boolean , 
      default : false , 
    } , 
    // closeHandler : Function , 
  } , 
  computed : {
    openOrClose () {
      return this.crntObj.obj.openBln ; 
    } , 
  } , 
  mounted () {} , 
  methods : {
    dimmedClickHandler ( e ) {
      if ( !this.crntObj.obj.openBln ) return ; 
      if ( !this.$refs.contentWrap.contains( e.target ) ) {
        this.crntObj.closeHandler() ; 
      }
    } , 
  } , 
}
</script>

<style lang="scss" scoped>
.popupWrap {
  border: 1px solid #000;
  position: fixed; 
  z-index: 99; 
  left: 0; top: 0; width: 100%; height: 100%; 
  display: flex; 
  justify-content: center; align-items: center; 
  visibility: hidden; 
  transition: visibility 0.475s , backdrop-filter 0.475s; 
  backdrop-filter: blur( 0px ); 

  .contentWrap {
    display: flex; 
    flex-direction: column; 
    // width: 992px; 
    // height: 723px; 
    padding: 24px; 
    gap: 24px;
    background-color: $white; 
    border: 1px solid $gray-9; 
    position: relative; 
    opacity: 0; 
    transform: scale( 0 ); 
    transition-property: transform , opacity; 
    transition-duration: 0.475s , 0.475s; 
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);

    > h2 {
      display: flex; 
      flex-shrink: 0; 
      align-items: center; 
      height: 24px; 
    }

    .scrlWrap {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap; 
      align-items: flex-start;
      padding: 0px;
      // gap: 16px; 
      gap: 24px var( --default-gap ); 

      width: 944px;
      height: 627px;
      overflow: hidden; 
      overflow-y: auto;

      @include scrlbar;
    } // end of .scrlWrap 
    
    .closeBtn {
      font-size: 0; 
      width: 24px; height: 24px; 
      display: flex; 
      justify-content: center; 
      align-items: center; 
      position: absolute; 
      right: 24px; top: 24px; 
      cursor: pointer;
      svg {
        width: 14px; height: 14px; 
      }
    } // end of .closeBtn 
  } // end of .contentWrap

  &.active {
    visibility: visible; 
    // backdrop-filter: blur( 2px ); 
    .contentWrap {
      opacity: 1; 
      transform: scale( 1 ); 
    }
  } // end of .active 
} // end of .popupWrap
</style>